import React, {Component}       from 'react';
import {compose}                from "redux";
import {connect}                from "react-redux";
import {withTranslation}        from "react-i18next";
import {isProperty, setPropertyId, isDefined, userLogout, setPropertyName} from "../../../../../utils/index";
import {history} from "../../../../../utils/history";
import {CONTENT, CONTENT_INFORMATION, LOGIN, MOBILE_LOGIN_SHORT} from "../../../../../constants/appUrls.constants"
import {getPropertyList}         from '../../../../../redux/actions/propertyActions'
import {onCreatePropertySubmit} from "../../../../../redux/actions/createPropertyActions";
import PropertyButtons          from "../../../../organisms/PropertyButtons/PropertyButtons";
import ColAtm                   from "../../../../atomic/Col/Col";
import BlockAtm from "../../../../atomic/Block/Block";
import ButtonAtm from "../../../../atomic/Button/Button";
import { Redirect } from 'react-router-dom';
import {Grid} from "@material-ui/core";
import {PageTitle} from "../../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../../atomic/PageHeader/PageHeader";
import {Animated} from "react-animated-css";
import Container from "@material-ui/core/Container";
import LabelAtm from "../../../../atomic/Label/Label";
import {logout,clearState} from "../../../../../redux/actions/userActions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash/debounce';
import ClearIcon from '@material-ui/icons/Clear';
import {Skeleton} from "@material-ui/lab";

// Kademeli (progressive) render ayarları — 300+ property tek seferde DOM'a basılmasın diye
const INITIAL_VISIBLE_COUNT = 24;
const LOAD_MORE_CHUNK = 24;

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

class propertySelect extends Component {

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            open: false,
            createConfirmOpen: false,
            searchTerm: '',
            debouncedSearchTerm: '',
            visibleCount: INITIAL_VISIBLE_COUNT
        };
        this.handleDebouncedSearch = debounce(this.handleDebouncedSearch, 300);

        // Ekrandaki kutu sayısını kaydırmaya göre artıran gözlemci.
        // IntersectionObserver desteklenmiyorsa (çok eski tarayıcı) tüm liste basılır.
        this.sentinelNode = null;
        this.observer = typeof IntersectionObserver !== 'undefined'
            ? new IntersectionObserver(this.handleIntersect, { rootMargin: '400px 0px' })
            : null;
    }

    handleIntersect = (entries) => {
        if (!entries.some(entry => entry.isIntersecting)) {
            return;
        }
        this.setState(prevState => {
            const filteredLength = this.getFilteredList().length;
            if (prevState.visibleCount >= filteredLength) {
                return null;
            }
            return {
                visibleCount: Math.min(prevState.visibleCount + LOAD_MORE_CHUNK, filteredLength)
            };
        });
    };

    // Sentinel div'i mount/unmount oldukça gözlemciye bağla/çöz
    setSentinelRef = (node) => {
        if (!this.observer) {
            return;
        }
        if (this.sentinelNode) {
            this.observer.unobserve(this.sentinelNode);
        }
        this.sentinelNode = node;
        if (node) {
            this.observer.observe(node);
        }
    };

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    getFilteredList = () => {
        const { property_list } = this.props;
        const { debouncedSearchTerm } = this.state;

        if (!property_list || property_list.length === 0) {
            return [];
        }

        return property_list.filter(property =>
            property?.name &&
            property.name.toLocaleLowerCase('tr').includes(debouncedSearchTerm.toLocaleLowerCase('tr'))
        );
    };

    handleClickOpen = () => {
        this.setState({open: true})
    };

    handleClose = () => {
        this.setState({open: false})
    };

    componentDidMount() {
        document.body.style.backgroundColor = "#f4f7fc";
        const {getPropertyList} = this.props;
        getPropertyList();
        this.setState({ redirect: false });

    }
    handleClick = (e, propertyName) =>{
        e.preventDefault();
        const { clearState } = this.props;
        let id = e.target.value;
        if( isDefined(id) ) {
            setPropertyId(id);
            setPropertyName(propertyName);

            // Otel degisiyor: localStorage yeni oteli gosterirken redux hala
            // oncekinin verisini tutuyor. Bircok reducer PENDING'de eski veriyi
            // koruyor (orn. generalInformationReducer, dashboardReducers,
            // propertyRoomAndRateReducers `...state` ile devam ediyor).
            //
            // NOT: Bu bir savunma, giderilmis bir hata degil. Genel Bilgiler ve
            // Odalar sayfalarinda bayat verinin ekrana bastigi DOGRULANAMADI —
            // ikisi de `fetching` bayragi doluyken icerigi hic render etmiyor.
            // Yine de tum ekranlar icin ayni garantiyi veremedigimizden, otel
            // degisimini logout'la ayni bilinen-iyi duruma indirgiyoruz:
            // giristen sonraki durumun aynisi, uygulama bu hali zaten isliyor.
            clearState();

            isProperty() ? history.push(CONTENT) : history.push("/")
        }
    };

    handleOpenCreateConfirm = (e) => {
        e.preventDefault();
        this.setState({ createConfirmOpen: true });
    };

    handleCloseCreateConfirm = () => {
        this.setState({ createConfirmOpen: false });
    };

    handleCreateProperty = () => {
        this.setState({ createConfirmOpen: false });
        this.props.onCreatePropertySubmit(this.state);
        this.setState({ redirect: true });
    };

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchTerm: value });
        this.handleDebouncedSearch(value);
    }

    handleDebouncedSearch = (value) => {
        this.setState({ debouncedSearchTerm: value });
    }

    getPropertyBoxStyle = (property) => (
        property.default_photo === "/assets/img/placeholder.png" ?
            {
                backgroundImage: "url(" + property.default_photo +")",
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#ccced5',
                backgroundPosition: 'center',
                backgroundSize: '38px',
                color: 'transparent',
                borderRadius: '0px',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px'
            }
            :
            {
                backgroundImage: "url(" + property.default_photo +")",
                backgroundRepeat: 'round',
                color: 'transparent',
                borderRadius: '0px',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px'
            }
    );

    // Tek property + daha önce seçilmemişse otomatik yönlendir
    selectPropertyID = (visibleList) => {
        const { property_list } = this.props;

        if (property_list.length === 0) {
            return null;
        }

        if (property_list.length === 1 && localStorage.getItem("property") === null) {
            const property = property_list[0];
            setPropertyId(property.id);
            setPropertyName(property.name);
            return <Redirect to={CONTENT} />;
        }

        return visibleList.map((property) => (
            property !== null && (
                <ColAtm xs={6} sm={4} md={3} xl={3} key={property.id} value={property.id}>
                    <PropertyButtons
                        blockClassName="property-box"
                        value={property.id}
                        text={property.name}
                        buttontext={property.name}
                        tooltip={property.name}
                        labelClass="property-box__title"
                        className="properties"
                        onClick={(e) => this.handleClick(e, property.name)}
                        style={this.getPropertyBoxStyle(property)} />
                </ColAtm>
            )
        ));
    };

    // fetching sırasında / kaydırırken gösterilecek iskelet kutular — gerçek property kartıyla aynı yapı
    renderSkeletons = (count) => (
        Array.from({ length: count }).map((item, key) => (
            <ColAtm xs={6} sm={4} md={3} xl={3} key={`skeleton-${key}`}>
                <div style={{ width: '100%', padding: '0 8px 16px', boxSizing: 'border-box' }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: 8,
                        boxShadow: '0 2px 10px rgba(45, 48, 57, 0.08)',
                        overflow: 'hidden'
                    }}>
                        <div style={{ padding: '16px 16px 12px' }}>
                            <Skeleton variant="text" animation="wave" width="70%" height={20} style={{ borderRadius: 4 }} />
                        </div>
                        <Skeleton variant="rect" animation="wave" width="100%" height={160} />
                    </div>
                </div>
            </ColAtm>
        ))
    );


    renderRedirect = () => {
        if (this.props.create_property.status === 200 && this.state.redirect) {
            localStorage.setItem('property', this.props.property_id);
            return <Redirect to={CONTENT_INFORMATION} />
        }
    };

    logOut = () => {
        const { logout } = this.props;
        logout();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {logoutStatus,clearState} = this.props

        // Arama değiştiğinde görünen kutu sayısını başa sar
        if (prevState.debouncedSearchTerm !== this.state.debouncedSearchTerm) {
            this.setState({ visibleCount: INITIAL_VISIBLE_COUNT });
        }

        if (prevProps.logoutStatus !== logoutStatus ){
            if(logoutStatus === 200){
                clearState()
                userLogout();
                if (isDefined(localStorage.getItem("mobile_login"))) {
                    history.push(MOBILE_LOGIN_SHORT + localStorage.getItem("mobile_login"));
                } else {
                    history.push(LOGIN);
                }
            }
        }
    }

    render() {
        const listCount = this.props.property_list;
        const { t, fetching } = this.props;
        const { open, createConfirmOpen } = this.state;

        const filteredList = this.getFilteredList();
        const visibleList = this.observer ? filteredList.slice(0, this.state.visibleCount) : filteredList;
        const hasMore = !!this.observer && this.state.visibleCount < filteredList.length;
        const isLoading = fetching && (!listCount || listCount.length === 0);

        return (
            <>
                <PageTitle title={ t('enw-select_property-page_title') }  />
                <PageHeaderAtm exitText={ t('btn-exit') }  text={ t('enw-select_property-title') } onClick={this.handleClickOpen}/>
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="property-container">
                            <BlockAtm>
                                <ColAtm className="justify-center">                                
                                    <LabelAtm style={{paddingBottom: listCount && listCount.length > 10 && 0}}  labelClass="property-label" text={ t('enw-select_property-desc') } />
                                </ColAtm>
                                {   // Search Bar
                                    listCount && listCount.length > 10 &&
                                        <ColAtm xs={12} sm={12} md={12} style={{ margin: '16px 0', padding: window.innerWidth < 768 ? '0px 10px' : '0px 18px 0px 0px' }}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                placeholder={t('btn-search')}
                                                value={this.state.searchTerm}
                                                onChange={this.handleSearchChange}
                                                style={{backgroundColor: '#fff', borderRadius: 8, color: '#2d3039'}}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon style={{color: '#2d3039'}} />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        this.state.searchTerm && (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="clear search"
                                                                    onClick={() => {
                                                                        this.setState({ searchTerm: '', debouncedSearchTerm: '' });
                                                                    }}
                                                                    edge="end"
                                                                    size="small"
                                                                >
                                                                    <ClearIcon style={{color: '#2d3039'}} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    ),
                                                }}
                                                inputProps={{
                                                    style: { fontSize: 16, paddingTop: 15, paddingBottom: 15, borderRadius: 8, color:'#2d3039'},
                                                    'aria-label': 'search',
                                                }}
                                            />
                                        </ColAtm>
                                }
                                <Grid
                                    container
                                    direction="row"
                                    justify={listCount.length < 2 ? "center" : "flex-start"}
                                    alignItems="center"
                                >
                                    { isLoading
                                        ? this.renderSkeletons(12)
                                        : this.selectPropertyID(visibleList) }

                                    { !isLoading && hasMore && (
                                        <>
                                            {this.renderSkeletons(4)}
                                            <div ref={this.setSentinelRef} style={{ width: '100%', height: 1 }} />
                                        </>
                                    )}

                                    { !isLoading && !hasMore && (
                                        <ColAtm xs={6} md={3}>
                                            <BlockAtm className="properties new-property" style={{height: '209px'}}>
                                                <ButtonAtm
                                                    className="properties new-property-btn"
                                                    startIcon={<i className="fas fa-plus" />}
                                                    onClick={this.handleOpenCreateConfirm}
                                                    buttontext={ t('btn-create_a_new_hotel') }
                                                />
                                                {this.renderRedirect()}
                                            </BlockAtm>
                                        </ColAtm>
                                    )}
                                </Grid>
                            </BlockAtm>
                        </div>
                    </Container>
                </Animated>
                <div>
                    <Dialog
                        open={open}
                        onClose={this.handleClose}
                        aria-labelledby="logout-modal"
                        className="logout-modal"
                        disableBackdropClick={true}
                    >
                        <DialogTitle id="logout-modal" className="red-bottom-border" onClose={this.handleClose}>{t('btn-exit')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText className="fs-18 f-w-600">
                                {t('enw-logout_exit-text')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <ButtonAtm
                                onClick={this.handleClose}
                                className="room-rate-modal-save bg-green m-0-8"
                                type="submit"
                                buttontext={ t('btn-back') }
                                color="primary"
                            />
                            <ButtonAtm
                                onClick={this.logOut}
                                className="room-rate-modal-save bg-red m-0-8"
                                type="submit"
                                buttontext={ t('btn-exit') }
                                color="primary"
                            />
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog
                        open={createConfirmOpen}
                        onClose={this.handleCloseCreateConfirm}
                        aria-labelledby="create-property-modal"
                        className="logout-modal"
                        disableBackdropClick={true}
                    >
                        <DialogTitle id="create-property-modal" className="red-bottom-border" onClose={this.handleCloseCreateConfirm}>{t('btn-create_a_new_hotel')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText className="fs-18 f-w-600">
                                {t('enw-create_property-confirm_text')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <ButtonAtm
                                onClick={this.handleCloseCreateConfirm}
                                className="room-rate-modal-save bg-dark-grey m-0-8"
                                type="button"
                                buttontext={ t('btn-go_back') }
                                color="primary"
                            />
                            <ButtonAtm
                                onClick={this.handleCreateProperty}
                                className="room-rate-modal-save bg-green m-0-8"
                                type="submit"
                                buttontext={ t('enw-input-checkbox-yes') }
                                color="primary"
                            />
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        );
    }
}
const mapStateToProps = (props) => {

    return{
        property_list : props.propertyReducer.property_list,
        fetching : props.propertyReducer.fetching,
        create_property : props.createPropertyReducer.create_property,
        property_id : props.createPropertyReducer.property_id,
        logoutStatus : props.userReducer.userLogoutStatus
    }
};


const mapDispatchToProps = {
    onCreatePropertySubmit,
    getPropertyList,
    logout,
    clearState
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(propertySelect));
